export default __webpack_public_path__ + "static/media/bubble_television.d615911f.mp3";